import React from 'react';

import { VisaExchangeCalculator as VisaExchangeCalculatorPackage } from '@eika-kortbetjening/visa-exchange-calculator';

import piwik from '@/piwik/piwik';
import { getAvailableCurrencies, getDetailedMarkup, getRateBothWays } from '@/react-query/services/visa-calculator';

import useText from '@hooks/use-text';

const VisaExchangeCalculator = () => {
    const text = useText();

    return (
        <VisaExchangeCalculatorPackage
            getAvailableCurrencies={getAvailableCurrencies}
            getDetailedMarkup={getDetailedMarkup}
            getRateBothWays={getRateBothWays}
            priceListPath="/priser"
            sitecoreDictionary={text}
            piwik={piwik}
        />
    );
};

export default VisaExchangeCalculator;
